import React from "react";
import SectionHeader from "@/components/shared/SectionHeader";
import { Leaf, Mountain, Wheat, Heart, ShieldCheck, BarChart3 } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const ICONS = [Mountain, Wheat, Heart, Leaf, BarChart3, ShieldCheck];

const BDSustainability = () => {
  const { t } = useI18n();
  return (
    <div>
      <section className="py-32 lg:py-40 bg-[#0A192F] text-white grain">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="overline text-[#D4AF37] mb-6">{t("sus.hero.eyebrow")}</div>
          <h1 className="font-bd text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02] max-w-4xl">
            {t("sus.hero.title.a")} <span className="text-[#D4AF37]">{t("sus.hero.title.b")}</span>
          </h1>
          <p className="mt-8 text-lg sm:text-xl text-white/75 max-w-3xl leading-relaxed">
            {t("sus.hero.body")}
          </p>
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <SectionHeader number={t("sus.pillars.number")} eyebrow={t("sus.pillars.eyebrow")} title={t("sus.pillars.title")} />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#0A192F]/10">
            {ICONS.map((Icon, i) => (
              <div key={i} className="bg-white p-10 lift-card">
                <div className="section-num">— {String(i + 1).padStart(2, "0")}</div>
                <Icon size={28} className="text-[#0A192F] mt-4" />
                <h3 className="font-bd text-xl text-[#0A192F] mt-3 tracking-tight">{t(`sus.pillars.${i}.title`)}</h3>
                <p className="mt-3 text-[#0A192F]/70 leading-relaxed text-sm">{t(`sus.pillars.${i}.desc`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BDSustainability;
